import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { Loading } from '@tencent/spaui';
import classnames from 'classnames';
import { guid as getGuid } from '@co-hooks/util';
var prefix = 'zhb-ui-loading';
var size2NumDict = {
  xxlg: 40,
  xlg: 32,
  lg: 24,
  md: 20,
  sm: 16
};
export var ZhbLoading = function ZhbLoading(props) {
  var loading = props.loading,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    children = props.children,
    _props$type = props.type,
    type = _props$type === void 0 ? 'wrap-block' : _props$type,
    className = props.className,
    style = props.style,
    iconStyle = props.iconStyle,
    iconClassName = props.iconClassName,
    _props$holdChildOnLoa = props.holdChildOnLoading,
    holdChildOnLoading = _props$holdChildOnLoa === void 0 ? false : _props$holdChildOnLoa,
    title = props.title;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(function () {
      return getGuid();
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    guid = _useState4[0];
  var iconStyleString = useMemo(function () {
    var sizeNum = typeof size === 'number' ? size : size2NumDict[size] || 24;
    return "\n    .".concat(prefix, "-").concat(guid, " {\n      .spaui-loading:before {\n        width: ").concat(sizeNum, "px;\n        height: ").concat(sizeNum, "px;\n        background-size: ").concat(sizeNum, "px ").concat(sizeNum, "px;\n      }\n    }\n    ");
  }, [size, guid]);
  var rootCls = classnames(prefix, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefix, "-").concat(guid), true), "".concat(prefix, "-active"), active), "".concat(prefix, "-wrap-fill"), type === 'wrap-fill'), "".concat(prefix, "-wrap-inline"), type === 'wrap-inline'), "".concat(prefix, "-icon"), type === 'icon'));
  useLayoutEffect(function () {
    setActive(loading);
  }, [loading]);
  var getIndicator = function getIndicator() {
    var inlineLoadingNode = React.createElement(Loading, {
      className: iconClassName,
      style: iconStyle,
      display: "inline-block"
    });
    if (type === 'icon') {
      return inlineLoadingNode;
    }
    if (!loading) {
      return null;
    }
    return React.createElement("div", {
      className: "".concat(prefix, "-mask")
    }, inlineLoadingNode, title && React.createElement("div", {
      className: "".concat(prefix, "-title")
    }, title));
  };
  var getChildren = function getChildren() {
    if (holdChildOnLoading && loading) {
      return null;
    }
    if (type === 'full-screen') {
      return null;
    }
    return children;
  };
  return React.createElement("div", {
    className: rootCls,
    style: style
  }, React.createElement("style", null, iconStyleString), getIndicator(), getChildren());
};